<template>
  <div id="app">
    <!-- <page-header v-if="toPath!=='/login'" /> -->
    <router-view v-if="isRouterAlive" />
    <btm v-if="!is_culture&&!$route.meta.hideFoot" />
    <imalert v-if="show_im && !$route.meta.hideIM" :im_gid="im_gid" :im_popupid="im_popupid"></imalert>
  </div>
</template>
<script>
// import pageHeader from '@/components/pageHeader'
import Cookies from 'js-cookie'
import btm from '@/components/pageBtm'
import { getimConf } from '@/api/im_api.js'
import { getMyZhulong } from '@/api/mine'

export default {
  components: {
    'btm': btm
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
      toPath: '',
      im_gid: '',
      im_popupid: '',
      show_im: false,
      // 是否是企业文化
      is_culture: false
    }
  },
  watch: {
    '$route'(to, from) {
      // 路由变化就请求
      // 企业文化不要
      if (to.path.indexOf('culture') != -1) {
        this.is_culture = true
      } else {
        this.is_culture = false
      }
      if (!this.is_culture) {
        this.getImConfig(to.path)
      }
      // this.isLogin(to, from)
      if (to.query.f) {
        // console.log(to.query.f)
        sessionStorage.setItem('f', to.query.f)
      }

      // // 第三方其他机构thirdtoken
      // if (window.location.href.includes('thirdtoken')) {
      //   const url = window.location.href
      //   const thirdtoken = this.getQueryString(url, 'thirdtoken')
      //   if (thirdtoken) {
      //     this.thirdTokenSetting(thirdtoken)
      //   }
      // }
    }
  },
  methods: {
    // 获取im配置信息
    getImConfig(toPath) {
      // agency_id 机构id
      // im_product_id  产品id
      // im_type 产品类型1课程 2普通产品 3链接
      // im_url ：链接地址
      // im_gid：接待组id

      // 默认false
      this.show_im = false

      const url = window.location.href
      var im_type = '3'
      var im_url = url
      var im_product_id = ''
      if (toPath === '/home') {
        // 课程
        const lesson_id = this.$route.query.lesson_id
        im_type = '1'
        im_product_id = lesson_id
        im_url = ''
      }
      const query = {
        agency_id: Cookies.get('agency_id') || '',
        im_type: im_type,
        im_product_id: im_product_id,
        im_url: im_url,
        im_gid: ''
      }
      // console.log('IM 配置', query)
      getimConf(query).then(res => {
        this.im_gid = String(res.im_gid) || ''
        this.im_popupid = String(res.im_popupid) || ''
        this.show_im = res.show || 0
        // console.log('展示IM', this.show_im)
      })
    },
    // 登录
    isLogin(to, from) {
      console.log(to.path)
      const cookie_uid = Cookies.get('uid')
      const cookie_uname = Cookies.get('username')
      if (!(cookie_uid && cookie_uname)) {
        // 未登录
        // console.log('没有登录')
        if (to.path !== '/login') {
          this.$router.replace('/login')
        }
      } else {
        // 已登录
        // console.log('已登录')
        if (to.path === '/login') {
          // 在登录页，跳转到首页
          this.$router.replace('/')
        }
      }
      // this.refresh = false
      // this.$nextTick(() => {
      //   this.refresh = true
      // })
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    },
    // 获取地址栏参数
    getQueryString(url, param) {
      // param为要获取的参数名 注:获取不到是为null
      var arr = url.split('?') // 分割域名和参数界限
      if (arr.length > 1) {
        arr = arr[1].split('&') // 分割参数
        for (var i = 0; i < arr.length; i++) {
          var tem = arr[i].split('=') // 分割参数名和参数内容
          if (tem[0] === param) {
            return tem[1]
          }
        }
        return null
      } else {
        return null
      }
    },
    // 第三方机构token设置
    thirdTokenSetting(token) {
      console.log(token, 'tokentokentoken')
      if (token && token.length > 0) {
        var thirdtoken = decodeURIComponent(token)
        // 1、存cookie
        Cookies.set('thirdtoken', thirdtoken)
        // 2、调需要登录的ucenterd的接口
        getMyZhulong().then(res => {
          console.log(res)
        })
      }
    }
  }
}
</script>>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
  padding: 0;
  min-height: 100%;
  // overflow: hidden;
  padding-top: 48px;
  font-size: 14px;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
html,body{
  height:100%;
  width: 100%;
}
body{
  margin: 0;
}
*{
  margin: 0;
  padding: 0;
}
p{
  margin: 0;
}
input:focus { outline: none; }
.ant-message{
  z-index: 9999 !important;
}
</style>
